const Cyan = {
  Cyan: {
    _000: '#ECFEFF',
    _400: '#22D3EE',
    _500: '#06B6D4',
  },
};

export default Cyan;
